import { GENERATED_SUMMARY_OPTION_ID } from '../components/header/types';

// True when a real artifact id is selected but the cached list lacks it (e.g. just
// generated) — the viewer/dropdown can't resolve it until a refetch.
export const isUnresolvedArtifactSelection = (selectedOptionId: string, artifacts: { id: string }[]): boolean =>
  selectedOptionId !== GENERATED_SUMMARY_OPTION_ID && !artifacts.some(a => a.id === selectedOptionId);
